/** @jsx jsx */
import React from "react"
import { jsx } from "theme-ui"
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';

export class MapContainer extends React.Component {
    render() {
      return (
        <div sx={{ 
            height: '10rem', 
            width: '100%', 
            overflow: 'hidden', 
            mt: 2, 
            borderRadius: 2 }}>
                <Map
                    google={this.props.google}
                    zoom={8}
                    containerStyle={{
                        position: 'static'
                    }}
                    style={{position: 'static', width: '100%', height: '100%', borderRadius: '8px' }}
                    initialCenter={{ lat: 47.444, lng: -122.176}}
                >
                    <Marker />
                </Map>
        </div>
      );
    }
  }

export default GoogleApiWrapper({
    apiKey: 'AIzaSyC7UNzULhJF_UX6qfW80qyN8IeVxPL4QGM'
  })(MapContainer)